import React from 'react';
import { Shield, Award, CheckCircle, Lock, MapPin, Building2 } from 'lucide-react';

interface Badge {
  name: string;
  icon: React.ReactNode;
  status: 'certified' | 'in-progress' | 'compliant';
  description: string;
}

const badges: Badge[] = [
  {
    name: 'Cyber Essentials Plus',
    icon: <Shield className="w-8 h-8" />,
    status: 'in-progress',
    description: 'Government-mandated security certification'
  },
  {
    name: 'ISO 27001',
    icon: <Award className="w-8 h-8" />,
    status: 'in-progress',
    description: 'Information security management system'
  },
  {
    name: 'G-Cloud 14 Supplier',
    icon: <CheckCircle className="w-8 h-8" />,
    status: 'in-progress',
    description: 'Direct award framework access'
  },
  {
    name: 'GDPR Compliant',
    icon: <Lock className="w-8 h-8" />,
    status: 'compliant',
    description: 'Full UK data protection compliance'
  },
  {
    name: 'UK Data Only',
    icon: <MapPin className="w-8 h-8" />,
    status: 'compliant',
    description: 'London & Manchester datacentres'
  },
  {
    name: 'Verified SME',
    icon: <Building2 className="w-8 h-8" />,
    status: 'compliant',
    description: 'Small and medium enterprise supplier'
  }
];

export default function CertificationBadges() {
  return (
    <div className="py-12 bg-gray-900/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-white mb-2">
            Trusted by UK Public Sector
          </h2>
          <p className="text-gray-400">
            Meeting government security and compliance standards
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge) => (
            <div
              key={badge.name}
              className="relative group"
            >
              <div className={`
                p-6 rounded-xl border-2 transition-all duration-300
                ${badge.status === 'certified'
                  ? 'border-green-500/50 bg-green-500/10'
                  : badge.status === 'in-progress'
                  ? 'border-blue-500/50 bg-blue-500/10'
                  : 'border-gray-500/50 bg-gray-500/10'
                }
                hover:scale-105 hover:shadow-lg
              `}>
                <div className="flex flex-col items-center text-center">
                  <div className={`
                    mb-3
                    ${badge.status === 'certified'
                      ? 'text-green-400'
                      : badge.status === 'in-progress'
                      ? 'text-blue-400'
                      : 'text-gray-400'
                    }
                  `}>
                    {badge.icon}
                  </div>
                  <h3 className="text-sm font-semibold text-white mb-1">
                    {badge.name}
                  </h3>
                </div>
              </div>

              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                <div className="bg-gray-800 text-white text-xs rounded-lg py-2 px-3 whitespace-nowrap shadow-xl border border-gray-700">
                  {badge.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
